import { createI18n } from "vue-i18n";

import common_kor from '@/locales/kor/Common.json';
import etc_kor_new from '@/locales/kor/Etc.json';
import common_eng from '@/locales/eng/Common.json';
import etc_eng from '@/locales/eng/Etc.json';
import gptBanMng_eng from '@/locales/eng/gptMng/GptBanMng.json';
import chatData_eng from '@/locales/eng/gptMng/ChatbotData.json';

/* 바뀐 다국어 처리 완료되면 삭제예정 */
/*
import dashboard_kor from '@/locales/kor/home/DashBoard.json';
import etc_kor from '@/locales/kor/etc/Etc.json';
import productionMng_kor from '@/locales/kor/vehicleMng/ProductionMng.json';
import deviceMng_kor from '@/locales/kor/vehicleMng/DeviceMng.json';
import infoCheck_kor from '@/locales/kor/vehicleMng/InfoCheck.json';
import modelMng_kor from '@/locales/kor/vehicleMng/ModelMng.json';
import vehicleSttsMng_kor from '@/locales/kor/vehicleMng/VehicleSttsMng.json';
import consMng_kor from '@/locales/kor/vehicleMnt/ConsMng.json';
import osTransMng_kor from '@/locales/kor/vehicleMnt/OsTransMng.json';
import report_kor from '@/locales/kor/vehicleMnt/Report.json';
import sosCall_kor from '@/locales/kor/vehicleMnt/SosCall.json';
import orgMng_kor from '@/locales/kor/userMng/OrgMng.json';
import userAppMng_kor from '@/locales/kor/userMng/UserAppMng.json';
import driveData_kor from '@/locales/kor/statCheck/DriveData.json';
import operationData_kor from '@/locales/kor/statCheck/OperationData.json';
import remote_kor from '@/locales/kor/remote/Remote.json';
import afterService_kor from '@/locales/kor/remote/AfterService.json';
import reProgram_kor from '@/locales/kor/remote/ReProgram.json';
import myInfo_kor from '@/locales/kor/popup/MyInfo.json';
import popup_kor from '@/locales/kor/popup/Popup.json';
import banMng_kor from '@/locales/kor/partsConsSales/BanMng.json';
import cateMng_kor from '@/locales/kor/partsConsSales/CateMng.json';
import partsCons_kor from '@/locales/kor/partsConsSales/PartsCons.json';
import login_kor from '@/locales/kor/login/Login.json';
import faqMng_kor from '@/locales/kor/customerService/FaqMng.json';
import noticeMng_kor from '@/locales/kor/customerService/NoticeMng.json';
import postMng_kor from '@/locales/kor/customerService/PostMng.json';

import dashboard_eng from '@/locales/eng/home/DashBoard.json';
*/

//현재 사용자 브라우저 언어셋 가져오기
const getLanguage = () => {    
    let lang = navigator.language || navigator.userLanguage || navigator.systemLanguage || 'en';

    //브라우저 언어가 영어 설정이 아닐때 강제로 언어를 영문으로 요청(추후 언어가 추가되면 수정필요)
    if (!lang.toLowerCase().includes('en')) {
    //if (!lang.toLowerCase().includes('en') && !lang.toLowerCase().includes('ko')) {
        lang = 'en';
    }

    let langArr = lang.split("-");
    if (langArr.length > 1) {
        lang = langArr[0];
    }
    
    return lang;
}

const messages = {
    en: {
        ...common_eng,
        ...etc_eng,
        ...gptBanMng_eng,
        ...chatData_eng
        // 기존 작업 내용(추후 삭제예정)
        //...dashboard_eng
    },
    ko: {
        ...common_kor,
        ...etc_kor_new,
        // 기존 작업 내용(추후 삭제예정)
        // ...dashboard_kor,
        // ...etc_kor,
        // ...productionMng_kor,
        // ...deviceMng_kor,
        // ...infoCheck_kor,
        // ...modelMng_kor,
        // ...vehicleSttsMng_kor,
        // ...consMng_kor,
        // ...osTransMng_kor,
        // ...report_kor,
        // ...sosCall_kor,
        // ...orgMng_kor,
        // ...userAppMng_kor,
        // ...driveData_kor,
        // ...operationData_kor,
        // ...remote_kor,
        // ...afterService_kor,
        // ...reProgram_kor,
        // ...myInfo_kor,
        // ...popup_kor,
        // ...banMng_kor,
        // ...cateMng_kor,
        // ...partsCons_kor,
        // ...login_kor,
        // ...faqMng_kor,
        // ...noticeMng_kor,
        // ...postMng_kor
    },
};

const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    //locale: 'en',
    locale: getLanguage(),
    fallbackLocale: 'en',
    messages,
});

export default i18n;